import DefaultProgressiveProfile from './DefaultProgressiveProfile';
import { useWwwLocation } from '../../../../composables/useWwwLocation';

export default class ReferToDiscoProgressiveProfile extends DefaultProgressiveProfile {
  public override onClient(): void {
    super.onClient();
    try {
      const { getInitParam } = useWwwLocation();
      const refCode = getInitParam('referralCode');
      if (refCode) {
        const newLoc = new URL(document.location.href);
        newLoc.searchParams.delete('referralCode');
        newLoc.searchParams.set('refCode', refCode);
        newLoc.searchParams.set('v2', 'true');
        document.location.href = newLoc.href;
      }
    } catch (e) {
      console.error('Error processing referral code:', e);
    }
  }
}
